class FramedPosterOptions extends HTMLElement {
  connectedCallback() {
    this.innerHTML = /* html */ `
        <div class="js-toggle-for-material" data-material="framed-poster">
            <p>
            <strong>Kies je formaat</strong>
            </p>
            <div class="js-poster-size d-flex mb-4">
            <div
                class="js-size-option style-option size p-2 mr-1"
                data-size="small"
                data-price="37.95"
            >
                <strong>S</strong><small>(21x30cm)</small>
                <hr class="my-2" />
                <small>€37,95</small>
            </div>
            <div
                class="js-size-option style-option size p-2 mr-1"
                data-size="medium"
                data-price="49.95"
            >
                <strong>M</strong><small>(30x40cm)</small>
                <hr class="my-2" />
                <small>€49,95</small>
                <span class="badge loved mt-2 mx-auto">Bestseller</span>
            </div>
            <div
                class="js-size-option style-option size p-2 mr-1"
                data-size="large"
                data-price="74.95"
            >
                <strong>L</strong><small>(50x70cm)</small>
                <hr class="my-2" />
                <small>€74,95</small>
            </div>
            </div>
        </div>
        <div class="js-toggle-for-material" data-material="framed-poster">
            <p><strong>Kies je lijst</strong></p>
            <div class="js-poster-frame d-flex mb-3">
            <div
                class="js-frame-option framed style-option frame-option p-2 mr-1"
                data-frame="white"
            >
                <img
                src="https://wallable.nl/wp-content/uploads/2025/05/white-frame.webp"
                width="50px"
                class="mb-2 mx-auto"
                />
                <strong>Witte lijst</strong> (hardhout)
            </div>
            <div
                class="js-frame-option framed style-option frame-option p-2 mr-1"
                data-frame="black"
            >
                <img
                src="https://wallable.nl/wp-content/uploads/2024/02/black-frame.webp"
                width="50px"
                class="mb-2 mx-auto"
                />
                <strong>Zwarte lijst</strong> (hardhout)
                <span class="badge loved mt-2 mx-auto">Bestseller</span>
            </div>
            <div
                class="js-frame-option framed style-option frame-option p-2 mr-1"
                data-frame="oak"
            >
                <img
                src="https://wallable.nl/wp-content/uploads/2024/02/oak-frame.webp"
                width="50px"
                class="mb-2 mx-auto"
                />
                <strong>Naturel lijst</strong> (eiken)
            </div>
            </div>
            <button class="btn btn-danger js-remove-frame w-100 mb-3"><i class="fa-solid fa-trash-alt"></i> Lijst verwijderen</button>
        </div>
    `;
  }
}

customElements.define("framed-poster-options", FramedPosterOptions);
